import React, { useContext, useState } from "react";
import { Box, Button, TextField } from "@mui/material";
import { UserContext } from "../../contexts/userContext";
import { useMutation } from "@apollo/client";
import { EDIT_USER } from "../../graphql/gqlUser";
import { SnackbarContext } from "../../contexts/snackbarContext";
import { T } from "../../components/T";

const AccountSettings = () => {
  const { user } = useContext(UserContext);
  const [firstName, setFirstName] = useState(user.firstName);
  const [lastName, setLastName] = useState(user.lastName);
  const [editUser] = useMutation(EDIT_USER);
  const [loading, setLoading] = useState(false);
  const { openErrorSnackbar, openSuccessSnackbar } =
    useContext(SnackbarContext);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (firstName === "") {
      openErrorSnackbar(<T str="First name is required" />);
      return;
    } else if (lastName === "") {
      openErrorSnackbar(<T str="Last name is required" />);
      return;
    }

    setLoading(true);

    editUser({ variables: { firstName, lastName } })
      .then(() => {
        openSuccessSnackbar(<T str="Profile updated" />);
        setLoading(false);
      })
      .catch((error: Error) => {
        openErrorSnackbar(error.message || <T str="Something went wrong" />);
        setLoading(false);
      });
  };

  return (
    <>
      <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="firstName"
          label={<T str="First name" />}
          name="firstName"
          value={firstName}
          color="secondary"
          onChange={(e) => {
            setFirstName(e.target.value);
          }}
        />
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="lastName"
          label={<T str="Last name" />}
          name="lastName"
          value={lastName}
          color="secondary"
          onChange={(e) => {
            setLastName(e.target.value);
          }}
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          sx={{ mt: 3, mb: 2 }}
          disabled={false}
        >
          {loading ? <T str="Updating..." /> : <T str="Update profile" />}
        </Button>
      </Box>
    </>
  );
};

export default AccountSettings;
